/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gotologin2Inputs */

const en_gotologin2 = /** @type {(inputs: Gotologin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to login`)
};

const de_gotologin2 = /** @type {(inputs: Gotologin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Anmelden`)
};

/**
* | output |
* | --- |
* | "Go to login" |
*
* @param {Gotologin2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const gotologin2 = /** @type {((inputs?: Gotologin2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gotologin2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gotologin2(inputs)
	return de_gotologin2(inputs)
});
export { gotologin2 as "goToLogin" }